import { Box } from '@mui/material'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { useTranslation } from 'react-i18next'
import { InfoRow, SectionHeader, useFormatFundingDate } from './shared'

interface Props {
  fundingSummary: FundingSummaryDto
}

const ClientInformation = ({ fundingSummary }: Props) => {
  const { t } = useTranslation()
  const formatFundingDate = useFormatFundingDate()

  const borrowerName =
    fundingSummary?.customerNameProvince?.split('/')[0]?.trim() ??
    fundingSummary?.customerNameProvince?.split(' / ')[0]?.trim() ??
    ''

  return (
    <Box>
      <SectionHeader>{t('fundingSummary.clientInformation')}</SectionHeader>

      <InfoRow label={t('fundingSummary.loanNumber')} value={fundingSummary?.loanNumber} />
      <InfoRow label={t('fundingSummary.beneficiaryProvince')} value={fundingSummary?.customerNameProvince} />
      <InfoRow label={t('fundingSummary.applicationNumber')} value={fundingSummary?.referenceNumber?.toString()} />
      {fundingSummary?.merchantReferenceCode && (
        <InfoRow
          label={t('fundingSummary.merchantReferenceCode')}
          value={fundingSummary.merchantReferenceCode}
        />
      )}
      <InfoRow label={t('fundingSummary.fundingDate')} value={formatFundingDate(fundingSummary?.activationOn)} />
      <InfoRow label={t('fundingSummary.borrower')} value={borrowerName} />
    </Box>
  )
}

export default ClientInformation
